export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
      
    },
    {
      title: true,
      name: 'Cadastros',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Centro de Custo',
      url: '/centro-de-custo',
      icon: 'cui-dollar',
    },
    {
      name: 'Cliente',
      url: '/cliente',
      icon: 'icon-people'
      
    },
    {
      name: 'Usuários',
      url: '/usuarios',
      icon: 'icon-user'
    },
    {
      name: 'Relatórios',
      url: '/relatorios',
      icon: 'icon-chart',
      children: [
        {
          name: 'Geral',
          url: '/relatorios/geral',
          icon: 'icon-puzzle'
        }
      ],
    },
    
  ]
}
